import DOC from './DOC.tsx';
import FileFormat from './FileFormat.tsx';
import JPG from './JPG.tsx';
import PDF from './PDF.tsx';
import PNG from './PNG.tsx';
import PPT from './PPT.tsx';
import XLS from './XLS.tsx';

export const FileTypeIcons = {
  DOC,
  FileFormat,
  JPG,
  PDF,
  PNG,
  PPT,
  XLS,
};

export default FileTypeIcons;
